import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InsuranceSolutions from "../pages/insurance-solutions/page";
import ServiceCenter from "../pages/service-center/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/insurance-solutions",
    element: <InsuranceSolutions />,
  },
  {
    path: "/service-center",
    element: <ServiceCenter />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
